jQuery(document).ready( function($) {

  const $foodSlider = $('#food-slider');
  const $foodSliderButtons = $('#food-slider-buttons');
  const $sliderBackgrounds = $('#slider-backgrounds');
  const $foodSliderNav = $('food-slider-nav');
  const $foodSliderIndicator = $('#food-slider-indicator');

  $foodSliderNav.slick({
     dots: false,
     arrows: false,
     draggable: false,
     slidesToShow: 4,
     fade: true,
     speed: 0,
     asNavFor: $('#food-slider')
   })

  $sliderBackgrounds.slick({
    dots: false,
    arrows: false,
    draggable: false,
    slidesToShow: 1,
    autoplay: false,
    infinte: false,
    fade: true,
    waitForAnimate: false,
    asNavFor: $foodSlider,
    responsive: [{
      breakpoint: 767,
      settings: {
        draggable: true,
      }
    }]
  })

  $foodSlider.slick({
     dots: false,
     arrows: false,
     draggable: true,
     slidesToShow: 1,
     autoplay: false,
     infinte: false,
     fade: true,
     waitForAnimate: false,
     asNavFor: $('#slider-backgrounds'),
     responsive: [{
       breakpoint: 767,
       settings: {
         dots: true,
         draggable: true,
         fade: false,
         autoplay: false,
         infinite: true,
       }
     }]
   })

   $('#food-slider-nav li').on('click', function(e){
     $('#food-slider-nav li').removeClass('active');
     var $activeNavItem = $(this);
     slideIndex = $(this).index();
     $foodSlider.slick('slickGoTo', parseInt(slideIndex) );
     $activeNavItem.addClass('active');
     $foodSliderIndicator.animate({
          'width' : $activeNavItem.outerWidth(),
          'left' : $activeNavItem.offset().left - $('#food-slider-nav-container').offset().left
        }, 500)
   })




})
